import { Component, Input, OnInit } from '@angular/core';
import { GeneralDialogComponent } from '../general-dialog.component';
import { MatDialog } from '@angular/material';
import { LEAVING_ARVEST_CMC } from '../../../../utilities/constants/misc.constants';

@Component({
  selector: 'external-link-dialog',
  templateUrl: '../general-dialog.component.html'
})
export class ExternalLinkDialogComponent extends GeneralDialogComponent implements OnInit {
  @Input() dialogHeader = 'Leaving Arvest Central Mortgage Company';
  @Input() dialogText = LEAVING_ARVEST_CMC;
  @Input() dialogType = 'externalLink';

  constructor(public dialog: MatDialog) {
    super(dialog);
  }

  ngOnInit() {
  }

}
